import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";

import { cn } from "@/lib/utils";

const Steps = TabsPrimitive.Root;

const StepsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center text-slate-500",
      className,
    )}
    {...props}
  />
));
StepsList.displayName = TabsPrimitive.List.displayName;

const StepsTrigger = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center w-10 h-10 rounded-full font-medium transition-all focus-visible:outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-white data-[state=active]:shadow-sm data-[state=active]:bg-primary data-[state=active]:border-primary bg-gray-100 border border-gray-200",
        className,
      )}
      {...props}
    >
      {children}
    </TabsPrimitive.Trigger>
  ),
);
StepsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const StepsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn("mt-2", className)}
    {...props}
  />
));
StepsContent.displayName = TabsPrimitive.Content.displayName;

export { Steps, StepsContent, StepsList, StepsTrigger };
